// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__21RUj","label":"Completed_label__1gHlX"};